import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client/react';
import { apolloClient } from './lib/apollo';
import { App } from './App';
import { watchSystemMode } from './lib/theme';
import './globals.css';
import './theme-skins.css';
import './ui-refinements.css';

// Live-follow the OS light/dark while in "system" mode (index.html did first paint).
watchSystemMode();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

createRoot(rootEl).render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </StrictMode>,
);
